<template>
  <div class="contents" :class="[currentView != 'Top'? 'isLower': '']" ref="content">
    <div class="contents__inner" ref="contentInner">
      <component :key="resetKey" :is="currentView" @transition="toScene"></component>
    </div>
    <div class="contents__bg bg" v-bind:style= "{'background-image':'url(images/pc/earth.jpg)' }">
      <div class="bg__moon">
        <img src="images/pc/moon.png" alt="">
      </div>
    </div>
    <div class="contents__bg2 bg2" v-bind:style= "{'background-image':'url(images/pc/pc_stone.png)' }">
      
      <div ref="comic1" class="bg2__comic bg2__comic--1" :style="{marginLeft: comic1Pos + 'px'}">
        <img src="images/pc/pc_comic_1.png" alt="">
      </div>
      <div ref="comic2" class="bg2__comic bg2__comic--2" :style="{marginRight: comic2Pos + 'px'}">
        <img src="images/pc/pc_comic_2.png" alt="">
      </div>
      <div ref="comic3" class="bg2__comic bg2__comic--3" :style="{marginRight: comic3Pos + 'px'}">
        <img src="images/pc/pc_comic_3.png" alt="">
      </div>
    </div>

    <div class="intro" v-if="!videoPlayed">
      <div class="intro__sound" v-if="!videoPlay" v-bind:style= "{'background-image':'url(images/draw/bg/bg_blue.jpg)' }">
        <div class="intro__sound-btns" v-if="onReady">
          <button class="intro__sound-btn" v-on:click="onSound(true)">
            <img src="images/top/btn_on.png" alt="">
          </button>
          <button class="intro__sound-btn" v-on:click="onSound(false)">
            <img src="images/top/btn_off.png" alt="">
          </button>
        </div>
        <div class="intro__sound-text" v-if="onReady">
          <img src="images/top/text_sound.png" alt="音声付きでお楽しみください">
        </div>
      </div>
      <div class="intro__player">
        <VimeoPlayer :video-id="videoId" :options="playerOption" :player-width=width :player-height=height @ready="onReady" @loaded="onLoaded" @ended="videoEnd" ref="player" class="player" id="player" />
        <button class="intro__skip" v-on:click="skip">
          <img src="images/top/btn_skip.png" alt="">
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import Top from '@/components/Top.vue'
import Story1 from '@/components/Story1.vue'
import Story2 from '@/components/Story2.vue'
import DrawStep1 from '@/components/DrawStep1.vue'
import DrawStep2 from '@/components/DrawStep2.vue'
import FreeDraw from '@/components/FreeDraw.vue'


export default {
  name: 'App',
  components: {
    Top,
    Story1,
    Story2,
    DrawStep1,
    DrawStep2,
    FreeDraw,
  },
  data: function() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      currentView: 'Top',
      resetKey: 0, // 増やすとコンポーネントがリセットされる

      videoId: "661083645",
      playerOption: {
        muted: true,
        autoplay: false,
        controls: false,
        loop: false,
        // responsive: true
      },
      isReady: false,
      videoPlay: false,
      videoPlayed: false,
      $iframe: null,

      comic1Pos: 0,
      comic2Pos: 0,
      comic3Pos: 0,

    }
  },
  mounted() {
    
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    toScene(...args) {
      this.$refs.content.scrollTop = 0;

      window.scroll({top: 0});

      if(this.currentView == args[0]) {
        this.refresh()
      }else { 
        this.currentView = args[0]
      }
    },

    refresh() {
      this.resetKey++
    },
    resize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      // let vh = window.innerHeight * 0.01;
      // document.documentElement.style.setProperty('--vh', `${vh}px`);


      if(this.$iframe){
        if(750 < this.width) {
          this.$iframe.width = 390
          this.$iframe.style.width = '390px'
        }else {
          this.$iframe.width = this.width
          this.$iframe.style.width = this.width + 'px'
        }
        this.$iframe.height = this.height
        this.$iframe.style.height = this.height + 'px'
      }

      if(750 < this.width){
        if(!this.$refs.contentInner) return

        let contentMargin = (this.width - this.$refs.contentInner.clientWidth) / 2
        
        this.comic1Pos = (contentMargin - this.$refs.comic1.clientWidth) / 2
        this.comic2Pos = (contentMargin - this.$refs.comic2.clientWidth) / 2 * 0.7
        this.comic3Pos = (contentMargin - this.$refs.comic3.clientWidth) / 2 * 1.2
        
      }
    },

    onSound(flag) {
      if(flag) {
        this.$refs.player.unmute()
      }else {
        this.$refs.player.mute()
      }
      this.videoPlay = true
      this.$refs.player.play()
    },

    onReady() {
      // console.log("onReady")
      // video dom
      let element = document.getElementById('player');
      let children = element.childNodes;

      this.$iframe = children[0]

      this.resize()
    },

    onLoaded() {
      // console.log("onLoaded")
      this.isReady = true
    },

    videoEnd() {
      // console.log("videoEnd")
      this.videoPlayed = true
    },

    skip() {
      // console.log("skip")
      this.$refs.player.pause()
      this.videoPlayed = true
    }
  },
  computed: {

  }
}
</script>

<style lang="scss">

#app {
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.contents {
  background: #000;
  height: 100%;
  min-height: 100%;
  position: relative;
  width: 100%;
  overflow-y: scroll;
  
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display:none;
  }

    &::after {
      content: "";
      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 9;
    }

  &__inner {
    background: #000;
    height: auto;
    margin: 0 auto;
    min-height: 100%;
    max-width: 390px;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 10;

    @include mq_sp {
      max-width: 750px;
    }
  }

  .bg {
    display: none;

    @include mq_pc {
      background-position-x: right;
      background-position-y: top;
      background-repeat: no-repeat;
      background-size: cover;
      display: block;
      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      transition: filter 0.5s;
      width: 100%;
      z-index: 0;

      &__moon {
        bottom: 0;
        left: 0;
        position: absolute;
        width: percentage(885px / 3360px);
        z-index: 1;
      }
    }
  }

  .bg2 {
    display: none;

    @include mq_pc {
      display: block;
      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 2;


        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

      // &::before {
      //   content: "";
      //   height: 100%;
      //   left: 0;
      //   position: absolute;
      //   top: 0;
      //   width: 100%;
      // }
      
      &__comic {
        opacity: 0;
        position: absolute;
        transform: translateY(-50%);
        transition: all 0.5s ease-in;
      }
      
      &__comic--1 {
        left: 0;
        top: 50%;
        width: percentage(959px / 3360px);
        z-index: 1;
      }
      &__comic--2 {
        right: 0;
        top: 40%;
        width: percentage(796px / 3360px);
        z-index: 1;
      }
      &__comic--3 {
        right: 0;
        top: 70%;
        width: percentage(681px / 3360px);
        z-index: 2;
      }
    }
  }

  @include mq_pc {
    &.isLower {
      .bg {
        filter: blur(6px);
        transition: filter 0.5s;
      }

      .bg2__comic {
        opacity: 1;

        &--1 {
          transition: all 0.4s ease-in 0.2s;
        }
        &--2 {
          transition: all 0.4s ease-in 0.2s;
        }
        &--3 {
          transition: all 0.4s ease-in 0.3s;
        }
      }
    }
  }
}

.intro {
  background: #000;
  height: 100%;
  left: 50%;
  margin: 0 auto;
  max-width: 390px;
  position: fixed;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
  z-index: 500;
  
  @include mq_sp {
    left: 0;
    transform: translateX(0);
    max-width: 750px;
  }

  &__sound {
    align-items: center;
    background-position-x: center;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
  }

  &__player {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }

  &__sound-btns {
    display: flex;
    justify-content: center;
    margin-bottom: get_percent(calc_retina3(81px));
    width: 100%;
  }

  &__sound-btn {
    margin: 0 get_percent(calc_retina3(60px));
    width: get_percent(calc_retina3(222px));
  }

  &__sound-text {
    width: get_percent(calc_retina3(670px));
  }

  &__skip {
    bottom: 0;
    margin-bottom: get_percent(calc_retina3(120px));
    margin-right: get_percent(calc_retina3(108px));
    position: absolute;
    right: 0;
    width: get_percent(calc_retina3(155px));
    z-index: 10;
  }

  .player {
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;

    iframe {
      background: #000;
      left: 0px;
      margin: auto;
      position: absolute;
      right: 0px;
    }
  }

}

.c-footer {
  padding: get_percent(38px) 0 get_percent(12px);
  text-align: center;
  width: 100%;

  &__img {
    margin: 0 auto;
    width: get_percent(calc_retina3(306px));
  }
}


.c-btn--pixel {
  background: rgba($color: #000, $alpha: 0.8);
  border: solid 1px rgba($color: #FFF, $alpha: 0.8);
  border-radius: 6px;
  color: #FFF;
  display: block;
  font-size: 1.7rem;
  @include fontVw(17);
  // height: calc_retina3(225px);
  height: auto;
  padding: get_percent(calc_retina3(87px)) 0;
  margin: 0 auto;
  width: get_percent(calc_retina3(800px));

  @include mq_pc {
    font-size: 1.7rem;
  }
}

.c-btn--top {
  margin: 0 auto get_percent(calc_retina3(48px));;
  width: get_percent(calc_retina3(329px));
}

.c-header {
  padding-top: get_percent(30px);
  position: relative;

  &__logo {
    margin: 0 auto get_percent(20px);
    position: relative;
    width: get_percent(calc_retina3(1023px));
    z-index: 5;
  }

  &__bg {
    left: 0;
    position: absolute;
    top: 0;
    width: get_percent(calc_retina3(1170px));
    z-index: 4;
  }
}

</style>
